export default "__VITE_PUBLIC_ASSET__1bbc265d__"